import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-cheque-remittance-create',
  standalone: false,
  templateUrl: './cheque-remittance-create.component.html',
  styleUrl: './cheque-remittance-create.component.scss',
})
export class ChequeRemittanceCreateComponent {}
